import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from '../../Service/storage.service';

@Injectable({
  providedIn: "root",
})
export class UserRoleService {

  private userRoleSubject: BehaviorSubject<string>;

  userRole$: Observable<string>;

  constructor(private readonly storageService: StorageService) {
    this.userRoleSubject = new BehaviorSubject<string>(
      this.storageService.getItem("AspNetRole")
    );
    this.userRole$ = this.userRoleSubject.asObservable();
    this.startChecking();
  }

  private startChecking() {
    const newRole = this.storageService.getItem("AspNetRole");
    setInterval(() => {
      if (newRole !== this.userRoleSubject.value) {
        this.userRoleSubject.next(newRole);
      }
    }, 1000);
  }
}
